<template>
  <teleport to="body">
    <transition name="fade">
      <div
        v-if="isModalOpen"
        class="fixed top-0 left-0 p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
        @click.self="close"
      >
        <div class="relative bg-white max-w-420 w-full rounded-4 pl-20 pt-20 pr-16 pb-12">
          <div class="text-grey-main">
            <p class="text-22 font-black">{{ title }}</p>

            <slot />

            <InputModule
              v-model="password"
              name="password"
              type="password"
              placeholder="password"
              class="w-full"
              input-classes="px-22 py-13 rounded-10 border border-grey-10  anim-all"
              :has-background="false"
              shadow="focus:shadow-signup"
            />
            <p class="text-14 mb-20 mt-5 text-grey-main">* You only have {{ deletedAt }} left to do it.</p>
          </div>
          <div class="flex justify-end items-center">
            <ButtonModule
              text="No, thank you"
              :has-hover="true"
              class="text-grey-main text-15 mr-12"
              @click="close"
            />
            <ButtonModule
              :disabled="!password"
              text="Restore"
              class="rounded-10 bg-brand hover:bg-brand-hover px-35 py-12 text-white text-15"
              @click="restore"
            />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { ref, computed, defineComponent } from 'vue'

import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import InputModule from '@/components/shared/form-controls/InputModule'

import { preventBodyScroll } from '@/core/helper-functions'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: { ButtonModule, InputModule },

  props: {
    email: { type: String },
    title: { type: String },
    date: { type: String }
  },

  setup (props) {
    const { commit, dispatch } = useStore()
    const router = useRouter()

    const isModalOpen = ref(false)
    const password = ref('')

    const deletedAt = computed(() => {
      const day = 1000 * 60 * 60 * 24 // milliseconds in one day
      const currentDate = Date.parse(new Date())

      const daysLeft = 30 - Math.floor((currentDate - props.date) / day)

      return daysLeft === 1 ? `${daysLeft} day` : `${daysLeft} days`
    })

    function open () {
      preventBodyScroll(true)
      isModalOpen.value = true
    }

    function close () {
      preventBodyScroll(false)
      isModalOpen.value = false
      password.value = null
    }

    function restore () {
      if (password.value.trim()) {
        dispatch('restoreAccount', { email: props.email, password: password.value }).then(() => {
          router.push({ name: 'Books' })
          close()
        }).catch(_ => {
          commit('setNotification', { isVisible: true, message: 'Incorrect email or password. Please try again.', color: 'error' })
          close()
        })
      }
    }

    return {
      // refs
      isModalOpen,
      password,
      // computed
      deletedAt,
      // function
      open,
      close,
      restore
    }
  }
})
</script>
